import { MEUCUPOM_URL } from "../urls";

export const menuLinks = [
    { label: 'HOME', url: `${MEUCUPOM_URL}/` },
    { label: 'TOP CUPONS', url: `${MEUCUPOM_URL}/top-cupons/cupom-desconto-todos` },
    { label: 'CATEGORIAS', url: `${MEUCUPOM_URL}/categorias` },
    { label: 'LOJAS', url: `${MEUCUPOM_URL}/lojas` },
    { label: 'MEUCUPOM DEVOLVE', url: `${MEUCUPOM_URL}/devolve` },
    { label: 'TOP CASHBACKS', url: `${MEUCUPOM_URL}/top-cashback?utm_medium=menu-home` },
    { label: 'MEU CUPOM EMPRESAS', url: `${MEUCUPOM_URL}/clubes/?utm_medium=menu-home&utm_campaign=acquisition` },
];